import { motion } from "framer-motion";
import { RevealLines, Overline } from "./Reveal";

const REVIEWS = [
  {
    name: "Evelyn I.",
    text: "L'accompagnamento shopping ha trasformato qualcosa di frustrante e dispendioso in qualcosa di piacevole e consapevole. Un percorso meraviglioso, alla ricerca non solo del mio stile, ma della sicurezza che ho sempre sognato di trovare in me stessa.",
  },
  {
    name: "Nicola P.",
    text: "Ho sempre avuto difficoltà ad abbinare colori e capi, ma per lavoro devo vestire in modo elegante e professionale. Alina mi ha seguito in tutto, dall'armocromia allo shopping: oggi non ho più dubbi e so di trasmettere fiducia ai clienti anche grazie a come mi vesto.",
  },
  {
    name: "Simona C.",
    text: "Ho iniziato con l'armocromia e nel tempo ho aggiunto restyling guardaroba e accompagnamento shopping. Finalmente valorizzo i capi che ho e i miei acquisti sono sempre mirati. Un percorso che sta trasformando non solo il mio modo di vestire, ma la consapevolezza che ho di me.",
  },
  {
    name: "Sara Z.",
    text: "Con Alina ho svolto tantissime consulenze: armocromia, body shape, visagismo e restyling guardaroba. Un'esperienza molto positiva che ha cambiato il mio modo di fare acquisti: ora sono molto più consapevole e so come valorizzarmi al 100%.",
  },
];

export const Testimonianze = () => {
  return (
    <section
      id="testimonianze"
      className="relative py-24 sm:py-36 overflow-hidden"
      data-testid="testimonianze-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative z-10">
        <Overline className="mb-8">Testimonianze</Overline>
        <h2 className="font-display uppercase text-fuchsiabrand text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
          <RevealLines lines={["Le parole delle", "mie clienti"]} />
        </h2>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="relative bg-crema border border-espresso/10 p-8 sm:p-10 overflow-hidden shadow-[0_18px_50px_-32px_rgba(42,42,42,0.35)]"
              data-testid={`testimonial-${i}`}
            >
              <span className="absolute top-2 left-4 font-display text-[7rem] leading-none text-fuchsiabrand/20 select-none">
                &ldquo;
              </span>
              <p className="relative font-sans font-medium text-xl sm:text-2xl leading-[1.45] text-espresso pt-8">
                {r.text}
              </p>
              <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-fuchsiabrand">
                — {r.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
